<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm9>
                <h3>Přehled elektronických peněženek</h3>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-controls
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.klient }}</td>
                  <td>{{ props.item.stav_kc }}</td>
                  <td>{{ props.item.stav_eur }}</td>
                  <td>{{ props.item.stav_usd }}</td>
                  <td class="text-center">
                    <v-btn color="primary" class="elevation-0 ma-0">
                      <v-icon>remove_red_eyes</v-icon> Detail
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Klient', value: 'klient' },
        { text: 'Stav v KČ', value: 'stav_kc' },
        { text: 'Stav v EUR', value: 'stav_eur' },
        { text: 'Stav v USD', value: 'stav_usd' },
        { text: 'Detail', value: null, sortable: false, align: 'center' }
      ],
      items: [
        {
          klient: 'Jan Novák',
          stav_kc: '1 000 Kč',
          stav_eur: '40 €',
          stav_usd: '48 $'
        }
      ],
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  methods: {

  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Penezenka/PrehledPenezenek.vue